import { z } from "zod";

export const companySettingsSchema = z.object({
  companyName: z.string().max(200).optional(),
  taxId: z.string().max(50).optional(),
});

export type CompanySettingsInput = z.infer<typeof companySettingsSchema>;
